import httpClient from '@/api/httpClient';

const fetch = (investmentStrategySelected, investmentHorizon, investmentAmount) => {
    return httpClient.get('investment-diagram', {
        params: {
            investmentStrategyType: investmentStrategySelected.name,
            investmentHorizon,
            investmentAmount,
        },
    }).then(({ data }) => data);
};

export default {
    fetch,
};
